import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ServicesToCall } from './image';
type ImageState =
	| {
			image: File;
			status: 'success';
	  }
	| {
			image: null;
			status: 'idle' | 'uploading' | 'error';
	  };

@Component({
	selector: 'app-mobility-image-container',
	templateUrl: './mobility-image-container.component.html',
	styleUrls: ['./mobility-image-container.component.scss'],
})
export class MobilityImageContainerComponent {
	constructor() {}
	private readonly initialImageState: ImageState = { image: null, status: 'idle' };

	@Input() maxImages = 8;

	@Input() imagePrefix: string = '';

	@Input() uploadImageToServerCallback: (file: File) => Observable<Object>;

	@Output() readonly imageFinishedUploading = new EventEmitter<string>();

	images$: BehaviorSubject<Array<ImageState>> = new BehaviorSubject([{ ...this.initialImageState }]);

	addImage() {
		this.images$.next([...this.images$.value, { ...this.initialImageState }]);
	}

	handleNewImageUploaded(image: File, index: number) {
		let imageToUpdate = this.images$.value[index];
		if (index === this.images$.value.length - 1 && this.images$.value.length < this.maxImages) {
			this.addImage();
		}

		imageToUpdate.status = 'success';
		imageToUpdate.image = image;
		this.imageFinishedUploading.emit(image.name);
		this.images$.next(this.images$.value);
	}
}
